export class ManifestError {
  message?: string;

  constructor(opts?: Partial<ManifestError>) {
    if (opts?.message != null) {
      this.message = opts.message;
    }
  }
}
